module.exports = __webpack_public_path__ + "img/battletrip_title.812de6a7.png";